module.exports = __webpack_public_path__ + "img/ADL.17e9ef80.png";